import React, { useState, useEffect } from 'react';
import { Frown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StudentLostModalProps {
  onAcknowledge: () => void;
  isSubmitting: boolean;
}

export function StudentLostModal({ onAcknowledge, isSubmitting }: StudentLostModalProps) {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const canConfirm = countdown === 0 && !isSubmitting;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
    >
      <div className="flex flex-col items-center justify-center text-center p-6 max-w-md mx-auto">
        <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center mb-6">
          <Frown className="w-12 h-12 text-muted-foreground" />
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-3">
          Seu período de acesso terminou
        </h1>

        <p className="text-muted-foreground text-sm sm:text-base mb-6 leading-relaxed">
          Se você está recebendo esta mensagem, é porque você deixou de ser um estudante da Forja.
          Isso significa que sua assinatura não foi renovada ou você solicitou o reembolso da comunidade.
        </p>

        <div className="w-full bg-muted/50 rounded-lg p-4 mb-6 border border-border">
          <p className="text-sm text-foreground leading-relaxed">
            Para continuar tendo acesso a todo o ecossistema do <strong>Forja Hub</strong>, é
            necessário uma assinatura ativa — o Forja Hub é feito exclusivamente para alunos da
            comunidade <strong>A Forja Digital</strong>.
          </p>
        </div>

        <Button
          onClick={onAcknowledge}
          disabled={!canConfirm}
          className="w-full sm:w-auto min-w-[200px]"
        >
          {countdown > 0
            ? `OK, entendi (${countdown}s)`
            : isSubmitting
              ? 'Processando...'
              : 'OK, entendi'}
        </Button>
      </div>
    </div>
  );
}
